module.exports = __webpack_public_path__ + "static/media/document.525afcf0.svg";